import styled from 'styled-components';
import { darkgrey, tabsBorder, white } from 'styles/Colors';

export const SetLineupBottomBarWrapper = styled.div`
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.08);
  background-color: ${white};
  padding: 0 40px 0 40px;
  font-family: Lato;
  font-size: 15px;
  color: ${darkgrey};
  align-items: center;
  z-index: 10;
  justify-content: space-between;

  .MuiButton-root .MuiCircularProgress-root.MuiCircularProgress-indeterminate {
    width: 15px !important;
    height: 15px !important;
    margin-right: 10px;
  }
`;

export const LeftSide = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

export const Divider = styled.div`
  height: 24px;
  width: 1px;
  background-color: ${tabsBorder};
`;

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  .MuiButtonBase-root {
    opacity: 0.5;

    &:hover {
      box-shadow: none;
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:active {
      opacity: 0.5 !important;
      cursor: not-allowed;
      background-color: rgb(236, 105, 26) !important;
    }

    &:focus {
      box-shadow: none;
      outline: none;
    }
  }
`;
